// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"369":"52f0d18f","389":"38dc461d","453":"fc59b59b","732":"02cd075b","977":"da4a0777"}[chunkId] + ".chunk.js";
};